export default __webpack_public_path__ + "static/media/1636.146414f3.png";